import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { returnRefundByMonth: { getReturnRefundByMonth } } = apiUrls;

export const RETURN_REFUND_BY_MONTH_SUCCESS = 'RETURN_REFUND_BY_MONTH_SUCCESS';
export const RETURN_REFUND_BY_MONTH_LOADING = 'RETURN_REFUND_BY_MONTH_LOADING';

export const getReturnRefundByMonthData = ({ from, to }) => async (dispatch) => {
    try {
        const requestData = {
            ...getReturnRefundByMonth,
            url: getReturnRefundByMonth.url.replace('{from}', from).replace('{to}', to)
        };
        const data = await REQUEST(requestData);
        dispatch({
            type: RETURN_REFUND_BY_MONTH_SUCCESS,
            data,                
        })

    } catch (e) {
        dispatch({
            type: RETURN_REFUND_BY_MONTH_SUCCESS,
            data: {
                code: "",
                modal: null,
                notifications: null,
                paginationInfo: null
            },            
        })
    }

}

export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: RETURN_REFUND_BY_MONTH_LOADING,
        isLoading,
    });
}